<template>
  <div>
    <!-- Mobile -->
    <div
      class="mb-4 block w-full min-w-full cursor-default select-none overflow-hidden rounded-lg bg-white transition-all duration-300 hover:bg-gray-50 md:hidden"
    >
      <div
        class="SkeletonBox relative z-10 -mb-1 h-32 w-full rounded-t-lg object-cover object-center"
      />

      <div class="flex items-center p-4 pr-0">
        <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
          <div class="flex">
            <div>
              <div class="items-center truncate text-sm font-medium text-gray-800 xxs:flex">
                <div
                  class="SkeletonBox w-full text-left text-sm font-semibold text-transparent sm:text-base"
                >
                  Example Golf Club.....
                </div>
              </div>
              <div class="mt-1 flex">
                <div class="SkeletonBox flex items-center text-sm text-transparent">
                  <div class="flex items-center leading-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="map-marker-alt"
                      class="mr-1 h-3 w-3 text-transparent"
                      role="img"
                      viewBox="0 0 384 512"
                    >
                      <path
                        fill="currentColor"
                        d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
                      />
                    </svg>
                    12 miles
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="relative ml-5 flex h-full min-h-full">
          <!-- Heroicon name: chevron-right -->
          <svg
            class="mr-4 h-5 w-5 text-gray-700"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clip-rule="evenodd"
            />
          </svg>

          <div class="gradient absolute right-0 top-0 -mr-1 -mt-32 h-64 w-16" />
        </div>
      </div>
    </div>

    <!-- Desktop -->
    <div
      class="relative mb-4 hidden cursor-default select-none items-center justify-between overflow-hidden rounded-lg border bg-white p-4 transition-all duration-300 md:flex"
    >
      <div class="flex items-start">
        <div class="SkeletonBox z-10 h-32 w-56 rounded-lg" />

        <div
          class="ml-4 flex h-32 flex-col justify-between py-1"
          @click="navigate()"
        >
          <div class="flex">
            <div>
              <div class="items-center text-sm font-medium text-gray-800 xxs:flex">
                <div
                  class="w-full text-left text-base font-semibold leading-none text-secondary-500 sm:text-lg"
                >
                  <div class="brand-heading SkeletonBox inline-block text-2xl text-transparent">
                    Club Name Club Name...
                  </div>
                </div>
              </div>
              <div class="SkeletonBox my-1 mb-2 text-sm text-transparent">
                ------------------
              </div>
            </div>
          </div>

          <div class="flex">
            <div class="flex items-center text-sm text-transparent">
              <div class="SkeletonBox flex items-center leading-none">
                ------------
              </div>
            </div>
          </div>

          <div class="flex">
            <div class="flex items-center text-sm text-transparent">
              <div class="SkeletonBox flex items-center leading-none">
                ------------
              </div>
            </div>
          </div>

          <div class="flex">
            <div class="flex items-center text-sm text-transparent">
              <div class="SkeletonBox flex items-center leading-none">
                -------------------------
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  props: {},
};
</script>
